<template>
  <div class="package-view">
    <table class="table table-sm table-fixed table-bordered">
      <tbody>
        <tr class="thead-light">
          <th colspan="4">General</th>
        </tr>
        <tr>
          <td colspan="2">Module name</td>
          <td>{{$store.getters.selectedPackage.name}}</td>
          <td>&euro; {{$store.getters.selectedPackage.price || 0}}</td>
        </tr>
        <template v-for="eventId in Object.keys($store.getters.selectedPackage.includes)">
          <tr class="thead-light" :key="eventId">
            <th colspan="4">{{$store.getters.events[eventId].name}}</th>
          </tr>
          <tr v-for="opt in $store.getters.selectedPackage.options[eventId]" :key="opt.id">
            <td colspan="2" v-html="opt.option.summary"></td>
            <td>
              {{typeof $store.getters.getOptionData(opt.option.id) === 'boolean'
              ? $store.getters.getOptionData(opt.option.id) ? 'yes' : 'no'
              : $store.getters.getOptionData(opt.option.id) || 0}}
            </td>
            <td>&euro; {{$store.getters.getOptionData(opt.option.id) * opt.option.price || 0}}</td>
          </tr>
        </template>
        <tr class="thead-light">
          <th colspan="4">Price</th>
        </tr>
        <tr>
          <td colspan="3" class="text-right">Total (excl. BTW)</td>
          <td>&euro; {{$store.getters.totalPrice.toFixed(2)}}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-right">BTW (21%)</td>
          <td>&euro; {{($store.getters.totalPrice * 0.21).toFixed(2)}}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-right">Total (incl. BTW)</td>
          <td>&euro; {{($store.getters.totalPrice * 1.21).toFixed(2)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "PackageView"
};
</script>